import React, { useEffect, useState } from 'react';
import ReactLoading from 'react-loading';
import CoverPage from "../../components/CoverPage";
import { MainNavUser } from "../../components/header/MainNavUser";
import { FooterUser } from "../../components/footer/FooterUser";
import { ErrorView } from "../../pages/error/ErrorView";
import imgCoverPage from '../../assets/images/figure/about-us.svg';
import imgAboutBusiness from '../../assets/images/figure/business-deal-cpi9.svg';
import imgAboutTeam from '../../assets/images/figure/team-meeting.svg';
import imgAboutMission from '../../assets/images/figure/our-mission.svg';
import { toolService } from '../../services'
import '../../assets/scss/style.scss';

export const AboutUs = () => {

  let title = "About Us";
  document.title = title + ' | SNHA P.C';

  const [mainHeader, setMainHeader] = useState({
    layer: "",
    title: "",
    subtitle: "",
  });

  const [sectionOneSubOne, setSectionOneSubOne] = useState({
    title: "",
    paragraph: "",
    extraData: [],
  });

  const [sectionOneSubTwo, setSectionOneSubTwo] = useState({
    paragraph: "",
  });

  const [sectionTwo, setSectionTwo] = useState({
    title: "",
    paragraph: "",
    extraData: [{
      delay: "",
      icon: "",
      title: "",
      paragraph: "",
      reference: "",
    }],
  });

  const [isLoaded, setIsLoaded] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const sectionMain = async () => {
      setError(null);
      setIsLoaded(true);
      try {
        const response = await toolService.getLayerSection('about-us')
        const mainHeaderData = {
          layer: "ABOUT-US",
          title: response.data.data.mainHeader.mainHeaderTitle,
          subtitle: response.data.data.mainHeader.mainHeaderSubtitle,
        };
        setMainHeader(mainHeaderData);
        response.data.data.layerSections.forEach((section) => {
          const subsection = section.subSections[0];
          const subSection = {};
          if (subsection.subSectionTitle) {
            subSection["title"] = subsection.subSectionTitle;
          }
          if (subsection.subSectionParagraph) {
            subSection["paragraph"] = subsection.subSectionParagraph;
          }
          subSection["extraData"] = [];
          subsection.subSectionExtraData.forEach((extradata) => {
            const extraData = {};
            if (extradata.extraDataDelay) {
              extraData["delay"] = extradata.extraDataDelay;
            }
            if (extradata.extraDataIcon) {
              extraData["icon"] = extradata.extraDataIcon;
            }
            if (extradata.extraDataTitle) {
              extraData["title"] = extradata.extraDataTitle;
            }
            if (extradata.extraDataParagraph) {
              extraData["paragraph"] = extradata.extraDataParagraph;
            }
            if (extradata.extraDataReference) {
              extraData["reference"] = extradata.extraDataReference;
            }
            subSection.extraData.push(extraData);
          });

          if (section.subSections[1]) {
            const subsectionExtra = section.subSections[1];
            const subSectionExtra = {};
            if (subsectionExtra.subSectionParagraph) {
              subSectionExtra["paragraph"] = subsectionExtra.subSectionParagraph;
            }
            setSectionOneSubTwo(subSectionExtra);
          }
          switch (section.sectionName) {
            case "SECTION_ONE":
              setSectionOneSubOne(subSection);
              break;
            case "SECTION_TWO":
              setSectionTwo(subSection);
              break;
            default:
              break;
          }
        });
      } catch (error) {
        setError(error);
        console.log(error);
      }
      setIsLoaded(false);
    }
    sectionMain();
  }, []);

  if (isLoaded) {
    return (
      <div className="loader">
        <ReactLoading type={'bubbles'} color={'#112349'} height={100} width={100} className="d-flex mx-auto" />
        <h5>Loading...</h5>
      </div>
    )
  } else {
    if (error) {
      return (<ErrorView />)
    } else {
      return (
        <div>
          <MainNavUser />
          <CoverPage data={mainHeader} img={imgCoverPage} />
          <main role='main' className='flex-shrink-0 content'>
            <section id="details" className="details section-bg">
              <div className="container">
                <div className="row content">
                  <div className="col-md-4 order-1 order-md-2" data-aos="fade-left">
                    <img src={imgAboutBusiness} className="img-fluid" alt="img-about-business" />
                  </div>
                  <div className="col-md-8 pt-5 order-2 order-md-1" data-aos="fade-up">
                    <h3>{sectionOneSubOne.title} </h3>
                    <p className="paragraph">{sectionOneSubOne.paragraph}</p>
                  </div>
                </div>
                <div className="row content">
                  <div className="col-md-4" data-aos="fade-right">
                    <img src={imgAboutTeam} className="img-fluid" alt="img-about-team" />
                  </div>
                  <div className="col-md-8 pt-5" data-aos="fade-up">
                    <p className="paragraph">{sectionOneSubTwo.paragraph}</p>
                  </div>
                </div>
              </div>
            </section>

            <section id="details" className="details">
              <div className="container">
                <div className="row content ">
                  <div className="col-md-8 order-2 order-md-1" data-aos="fade-up">
                    <h3>{sectionTwo.title}</h3>
                    <p className="paragraph">{sectionTwo.paragraph}</p>

                    {sectionTwo.extraData.map((data, key) => {
                      return (
                        <div key={key} className="icon-box" data-aos="zoom-in" data-aos-delay={data.delay}>
                          <div className="icon"><i className={"feather " + data.icon} /></div>
                          <h4 className="title">{data.title}</h4>
                          <p className="description mb-0">{data.paragraph}</p>
                          <small className="font-italic font-bold float-right mr-4">{data.reference}</small>
                        </div>
                      );
                    })}
                  </div>
                  <div className="col-md-4 order-1 order-md-2 my-auto" data-aos="fade-left">
                    <img src={imgAboutMission} className="img-fluid" alt="img-about-mission" />
                  </div>
                </div>

              </div>
            </section>
          </main>
          <FooterUser />
        </div>
      );
    }
  }
}

